const Benefit360 = () => import('./Index.vue');

export const routes = [
  {
    path: 'beneficio-360/configuracoes',
    name: 'talkvia_benefit360_settings',
    meta: { permissions: ['administrator', 'custom_role'] },
    component: Benefit360,
    props: { mode: 'settings' },
  },
  {
    path: 'beneficio-360/campanhas/lista',
    name: 'talkvia_benefit360_campaign_list',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: () => import('./Campaigns.vue'),
    props: { mode: 'list' },
  },
  {
    path: 'beneficio-360/campanhas',
    name: 'talkvia_benefit360_campaigns',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: () => import('./Campaigns.vue'),
  },
  {
    path: 'beneficio-360',
    name: 'talkvia_benefit360',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: Benefit360,
  },
];
